import { render, staticRenderFns } from "./SettingService.vue?vue&type=template&id=2464bde8&scoped=true&"
import script from "./SettingService.vue?vue&type=script&lang=js&"
export * from "./SettingService.vue?vue&type=script&lang=js&"
import style0 from "./SettingService.vue?vue&type=style&index=0&id=2464bde8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2464bde8",
  null
  
)

export default component.exports